// services/jobService.js
// Author: Harshada Bhavsar (18/7/2025)
// API: Create Job Opening for Employee
import axios from "../../../../../axios";
import Cookies from "js-cookie";

export const createJobOpening = async (jobData) => {
  const token = Cookies.get("employeeToken");
  const formData = new FormData();

  Object.keys(jobData).forEach((key) => {
    if (key !== "jobDescription" && key !== "jobInterviewers") {
      formData.append(key, jobData[key] ?? "");
    }
  });

  if (Array.isArray(jobData.jobInterviewers)) {
    jobData.jobInterviewers.forEach((interviewer, index) => {
      formData.append(
        `JobInterviewers[${index}].InterviewerCode`,
        interviewer.interviewerCode,
      );
      formData.append(
        `JobInterviewers[${index}].InterviewSequence`,
        interviewer.interviewSequence,
      );
    });
  }

  if (jobData.jobDescription) {
    formData.append("JobDescription", jobData.jobDescription);
  }

  formData.append("Token", token);

  return axios.post("/api/Jobs/Employee/CreateJobOpening", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};
